// QR Code URL Configuration
// CRITICAL: These URLs are printed on physical labels that may last 1+ years
// Change with extreme caution!

const QR_CONFIG = {
  // Production URL for QR codes - THIS MUST BE PERMANENT
  // Options:
  // 1. Custom domain you own: 'https://ops.rewined.com'
  // 2. Railway URL: 'https://your-app.up.railway.app'
  // 3. Redirect service: 'https://qr.rewined.com'
  PRODUCTION_URL: process.env.REACT_APP_QR_BASE_URL || 'https://operations-production.up.railway.app',

  // Development URL (for testing only)
  DEVELOPMENT_URL: 'http://localhost:3000',

  // Whether to use production URL even in development (recommended: false)
  FORCE_PRODUCTION_IN_DEV: false,

  // Warning threshold - alerts if URL might not be permanent
  WARN_ON_TEMP_URL: true
};

// Get the appropriate QR base URL
export const getQRBaseUrl = () => {
  // ALWAYS use the permanent custom domain for QR codes
  // This ensures consistency across all environments
  return 'https://run.daydreamerconcepts.com';
};

// Generate QR code URL for a specific SKU
export const generateQRUrl = (sku) => {
  const baseUrl = getQRBaseUrl();
  return `${baseUrl}/ops/${encodeURIComponent(sku)}`;
};

// Generate QR code URL for a warehouse bin
export const generateBinQRUrl = (binCode) => {
  const baseUrl = getQRBaseUrl();
  return `${baseUrl}/bin/${encodeURIComponent(binCode)}`;
};

export default QR_CONFIG;